import "./OurOilPage2.module.css";
import Header from "@/reusable_sections/Header";
import NuestroAceite from "./sections/NuestroAceite";
import OurCollection from "./sections/OurCollection";
import CalidadYOrigen from "./sections/CalidadYOrigen";
import ImportantInformation from "./sections/ImportantInformation";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function OurOilPage2() {
  return <div>
      <Header />
      <NuestroAceite />
      <OurCollection />
      <CalidadYOrigen />
      <ImportantInformation />
      <CallToAction />
      <Footer />
    </div>;
}